module.exports = __webpack_public_path__ + "img/state_abnormal.61936cbc.png";